import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import useFetchUsers from '../../hooks/fetchUsers';
import { Pagination, Input, Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { EditTwoTone } from '@ant-design/icons';
import { dateConverter } from '../../utils/utcDateConversion';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';

function Kiosks() {
  const { t } = useTranslation(['common']);
  let { Search } = Input;
  let navigate = useNavigate();
  let users;
  const [form] = Form.useForm();

  let searchedUser;
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [fetchUsers, setFetchUsers] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [searchShow, setSearchShow] = useState(false);
  const [renderList, setRenderList] = useState();
  const [tableShow, setTableShow] = useState(true);
  const [resetForm, setResetForm] = useState(false);

  const [err, setErr] = useState('');
  const userResp = useFetchUsers();
  const token = getTokenfromUserObj();
  console.log(token);
  console.log(userResp);
  const userCount = userResp.response ? userResp.response.data.length : 0;
  console.log(userCount);
  useEffect(() => {
    const userList = async () => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user.userType === 'A') setEditBtn('block');
      const limit = 1000;
      const offset = 0;
      const kioskResp = await axios.get(`${app.URL}/kiosk/view`, { headers: { auth: token } });
      let convertedObj = dateConverter(kioskResp.data.data, 'createdOn');
      console.log('��� ~ file: Users.js:31 ~ userList ~ convertedObj', convertedObj);
      kioskResp.data ? setFetchUsers(convertedObj) : ' ';
      kioskResp.data ? setPagesCount(convertedObj.length) : ' ';
      kioskResp.data ? setRenderList(convertedObj.slice(0, 50)) : ' ';
    };
    userList();
  }, [resetForm]);
  const handleSearch = async () => {
    console.log('calling');
    try {
      const result = search ? await axios.get(`${app.URL}/user/search/${search}`) : [];
      console.log(result);
      searchedUser = result.data.data;
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }

    console.log(searchedUser);
    if (searchedUser) {
      setSearchShow(true);
      setRenderList(searchedUser);
    }
    console.log(searchedUser);
  };
  const onSearch = async (value) => {
    console.log(value);
    try {
      const result = await axios.post(`${app.URL}/kiosk/search/${value}`,{}, { headers: { auth: token } });
      console.log(result);
      searchedUser = result.data.data;
      setRenderList(searchedUser);
      setPagesCount(searchedUser.length);
      // result.data.data ? form.setFieldsValue({ ['search']: "" }) : '';  
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }
  };
  const onChange = async (page, pageSize) => {
    console.log(page);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    setRenderList(fetchUsers.slice(reqObj.offset, reqObj.offset + limit));
    console.log(renderList);
  };

  const handleSearchChange = (e) => {
    console.log(e.target.value);
    if (!e.target.value) {
      setRenderList(fetchUsers.slice(0, 50));
      //  console.log(organizations.length)
      setPagesCount(fetchUsers.length);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };

  const editKiosk = (e) => {
    console.log(e);
    localStorage.setItem('kioskId', JSON.stringify(e.kioskId));
    navigate('/kiosk/edit', { replace: true });
  };
  const addKiosk = () => {
    navigate('/kiosk/add', { replace: true });
  };
  console.log(renderList);

  const onStatusChange = async (event)=>{      
    const kioskResp = await axios.get(`${app.URL}/kiosk/view`, { headers: { auth: token } });    
    setRenderList(kioskResp.data.data.filter((item) => item.isActive === event));
  }

  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
      {/* title here */}
      {/* <div className='row mt-2'>
        <div className='col-lg-10 col-md-10 col-sm-10 fs-3 fw-bold'>{t('Kiosks')}</div>
      </div> */}

      {/* search bar */}
      {/* <div className='col-lg-7 mt-4'>
        <Search
          className='search'
          placeholder='Search Kiosk By Title'
          onChange={handleSearchChange}
          onSearch={onSearch}
          style={{
            width: 300,
          }}
        />
      </div> */}

      {/* other system */}

      {/* <div className='row text-right'>
        <div className='col-lg-7 mt-4'>
          <Search
            className='search'
            placeholder='Search Kiosk By Title'
            onChange={handleSearchChange}
            onSearch={onSearch}
            style={{
              width: 300,
            }}
          />
        </div>
        <div className='col-lg-4 col-md-2 col-sm-2 mt-4'>
          <button class='btn btn-primary button' onClick={addKiosk}>
            Add
          </button>
        </div>
      </div> */}

      <div className='row'>
        <div className='col-lg-8 col-md-8 col-sm-12 '>
          <div class='mt-4 fs-3 fw-bold'> {t('Kiosks')} </div>
        </div>

        <Form
          name='basic'
          form={form}
          initialValues={{
            remember: true,
          }}
          onFinish={() => {}}
          onFinishFailed={() => {}}
          autoComplete='off'
        >
          <div className='row text-left mt-4 mt-2'>
            <div className='col-lg-3 eventselect'>
              <Form.Item
                form={form}
                colon={false}
                name='statusType'
                rules={[
                  {
                    required: false,
                    message: 'Select Status Type',
                  },
                ]}
              >
                <Select
                  className='custom-select-dropdown'
                  listHeight={250}
                  listItemHeight={500}
                  onChange={onStatusChange}
                  style={{
                    display: 'inline-block ',
                  }}
                  placeholder='Select Status Type'
                >
                  <Option className='select-option' key={1} value={1}>
                    Active
                  </Option>

                  <Option className='select-option' key={2} value={0}>
                    Inactive
                  </Option>
                </Select>
              </Form.Item>
            </div>
            <div className='col-lg-2'>
              <button class='btn btn-primary button'
                onClick={() => {
                setResetForm(!resetForm);
                form.resetFields();

                }}
              
              >
                Clear
              </button>
            </div>
            <div className='col-lg-3'>
              <Form.Item
              name="search"
              >
                <Search
                  id='search'
                  className='event-search'
                  placeholder='Search Kiosk By Title'
                  onChange={handleSearchChange}
                  onSearch={onSearch}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();  // Prevents the form from submitting on Enter key press
                      onSearch(e.target.value);  // Calls the search function directly
                    }
                  }}
                  style={{
                    width: 300,
                    height: 50,
                  }}
                />
              </Form.Item>
            </div>
            <div className='col-lg-3 offset-lg-1 text-right col-md-4 col-sm-12'>
              <button class='btn btn-primary button' onClick={addKiosk}>
                Add
              </button>
            </div>
          </div>
        </Form>
      </div>

      <div className='col-lg-12 col-md-12 col-sm-12'>
        <div class=' styled-table '>
          <table class='table text-black'>
            <thead class='thead-light'>
              <tr>
                <th>{t('Organization')}</th>
                <th>{t('Reference No.')}</th>
                <th>{t('Name')}</th>
                <th>{t('Model')}</th>
                <th>{t('Registered On')}</th>
                <th>{t('App Version')}</th>
                <th>{t('Status')}</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {renderList
                ? renderList.map((output) => (
                    <tr
                      className='row-hover'
                      onClick={() => {
                        editKiosk(output);
                      }}
                    >
                    <td style={{ width: '250px' }}>{output.organizationName ? output.organizationName : <span style={{paddingLeft:'40px'}}>  -</span>   }</td>
                      <td style={{ width: '160px' }}>{output.kioskRef}</td>
                      <td
                        onClick={() => {
                          editKiosk(output);
                        }}
                        style={{ width: '160px' }}
                      >
                        {output.name ? output.name : 'null'}
                      </td>
                      <td style={{ width: '160px' }}>{output.model}</td>
                      <td style={{ width: '200px' }}>{output.createdOn}</td>
                      <td style={{ width: '200px' }}>{output.appVersion}</td>
                      <td style={{ width: '160px' }}>{output.isActive === 1 ? 'Active' : 'Inactive'}</td>
                      <td>
                        <EditTwoTone
                          displayName='edit'
                          twoToneColor='blue'
                          style={{ fontSize: '20px' }}
                          onClick={() => {
                            editKiosk(output);
                          }}
                        />
                        {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                      </td>
                    </tr>
                  ))
                : ' '}
            </tbody>
          </table>
          {renderList && renderList.length == 0 ? <NoRecordFound /> : ' '}
        </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
    </div>
    //     </div>
    //   </div>
    // </div>
  );
}

export default Kiosks;
